import { PureComponent, ErrorInfo, ReactNode } from 'react'
import Bugsnag from '@bugsnag/js'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends PureComponent<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ hasError: true })

    // eslint-disable-next-line no-underscore-dangle
    Bugsnag.notify(error, (event: any) => {
      // eslint-disable-next-line no-param-reassign
      event.context = 'ti-fts-widget'
      // eslint-disable-next-line no-param-reassign
      event.addMetadata = info
    })
  }

  render() {
    const { hasError, error } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <div>
          Bei der Verbindung zu Tink ist ein Fehler aufgetreten
          {error}
        </div>
      )
    }

    return <div>{children}</div>
  }
}
